import { CommissionInvoice } from '../../../types/models/commission/commission.types';
import { COMMERCIAL_ENDPOINTS } from '../../../utils/api/endpoints/commercialEndpoints';

const PREFIX = '[invoicesQuery]';

export const queryAllCommissionsInvoices = async () => {
  console.log(PREFIX, `Fetching invoices...`);
  const response = await COMMERCIAL_ENDPOINTS.getAllCommissionsInvoices();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received invoices.`);
  return json as CommissionInvoice[];
};
